/**
 * "Jane Doe" -> "Jane D." — the name format the bevnet.com header uses.
 *
 * A deliberate local copy of Core/NextJS/packages/utils/renderShortName.ts rather
 * than an import: Core/NextJS and Core/React are separate workspace roots (Turborepo
 * vs Lerna) with no shared package and no path mapping, and this is a craco build
 * that would not transpile TypeScript from outside its own root. It is also not in
 * @monorepo/common, which is shared with Account-front and Magazine and should not
 * grow a helper for a single consumer — promote it there if a second one appears.
 *
 * Keep the logic identical to the Next copy: same split, same fallback, and no
 * Array.prototype.at (which that copy avoids for the same target-compat reason).
 */
export const renderShortName = (fullName: string = ''): string => {
  const parts = fullName ? fullName.split(' ') : [];
  if (parts.length >= 2) {
    const firstName = parts[0];
    const lastName = parts[parts.length - 1];
    return `${firstName} ${lastName.charAt(0)}.`;
  }
  // No last name to initialise — show whatever we were given.
  return fullName;
};

export default renderShortName;
